import { render, staticRenderFns } from "./SuppressionPanel.vue?vue&type=template&id=18787d2a&scoped=true"
import script from "./SuppressionPanel.vue?vue&type=script&lang=js"
export * from "./SuppressionPanel.vue?vue&type=script&lang=js"
import style0 from "./SuppressionPanel.vue?vue&type=style&index=0&id=18787d2a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18787d2a",
  null
  
)

export default component.exports